var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconaHomeFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.99208 21.07594",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #2b2a28;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_1-2",
    "data-name": "Livello 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.926,7.12593a.51777.51777,0,0,1-.46.27.59.59,0,0,1-.25-.07l-.27-.15v11.27a2.63322,2.63322,0,0,1-2.63,2.63h-3.69a.525.525,0,0,1-.52-.53v-9.15h-4.22v9.15a.525.525,0,0,1-.52.53H3.676a2.63326,2.63326,0,0,1-2.63-2.63v-11.27l-.27.15a.52358.52358,0,0,1-.71-.2.5328.5328,0,0,1,.2-.72L9.736,1.146a.53437.53437,0,0,1,.52,0l4.66,2.59V.526a.52459.52459,0,0,1,.84-.42l2.11,1.58a.52506.52506,0,0,1-.63.84l-1.26995-.95v2.74l3.76,2.09A.53278.53278,0,0,1,19.926,7.12593Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconaHomeFill);
export default __webpack_public_path__ + "static/media/iconaHomeFill.9fcacfc7403274d90ec822cb7db7d1f0.svg";
export { ForwardRef as ReactComponent };